import { createStandardAction } from "typesafe-actions";

export const savePawnListFilters = createStandardAction("@@utils/SAVE_PAWN_LIST_FILTERS")();
export const savePawnListReceivedAtDates = createStandardAction("@@utils/SAVE_PAWN_LIST_RECEIVED_AT_DATES")();